import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Product } from 'shared/models/product';
import { ShoppingCart } from 'shared/models/shopping-cart';
import { ProductService } from 'shared/services/product.service';
import { ShoppingCartService } from 'shared/services/shopping-cart.service';
import { fade, fadeStagger, heartBeat } from 'src/app/animations';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css'],
  animations: [ fade, fadeStagger, heartBeat ]
})
export class ProductsComponent implements OnInit {
  products: Product[] = [];
  filteredProducts: Product[] = [];
  category: string;
  cart$: Observable<ShoppingCart>;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    public shoppingCartService: ShoppingCartService) {
  }

  async ngOnInit() {
    this.cart$ = await this.shoppingCartService.getCart();
    // this.cart$.pipe(take(1)).subscribe(x => this.cart = x);

    this.populateProducts();
  }

  private populateProducts() {
    this.productService.getAll()
      .subscribe(products => {
        this.products = <Product[]><unknown>products;

        this.route.queryParamMap.subscribe(params => {
          this.category = params.get('category');
          this.applyFilter();
        });
      });
  }

  private applyFilter() {
    this.filteredProducts = (this.category) ?
      this.products.filter(p => p.category === this.category) :
      this.products;
  }

  searchFilter(query: string) {
    this.filteredProducts = (this.category) ?
      this.products.filter(p => p.category === this.category && p.title.toLowerCase().includes(query.toLowerCase())) :
      this.products.filter(p => p.title.toLowerCase().includes(query.toLowerCase()));
  }
}
